import SubBanner from '@/components/common/Banner/SubBanner/SubBanner';
import InputSearch from '@/components/common/Input/InputSearch/InputSearch';
import InputSelect from '@/components/common/Input/InputSelect/InputSelect';
import TablePagination from '@/components/common/Pagination/TablePagination';
import ConferenceList from '@/components/Conference/ConferenceList/ConferenceList';
import useIsMobile from '@/hooks/useIsMobile';
import { useLocation, useNavigate } from 'react-router-dom';
import * as S from './style';
import infoBanner from '@/assets/img/banner/info.jpg';
import defaultImg from '@/assets/img/defaulmg.jpg';
import BoardTable from '@/components/common/Table/BoardTable/BoardTable';
import TabList from '@/components/common/Tab/TabList/TabList';
import { useState } from 'react';
import { tableOptions } from '@/constants/option';
import { useGetInfoApi } from '@/api/notice';
import dayjs from 'dayjs';
import useDebounce from '@/hooks/useDebounce';
import { convertInfoValue } from '@/utils/convertValue';
import { generateColumns } from '@/constants/table';

const InfoPlace = () => {
	const navigate = useNavigate();
	const isMoble = useIsMobile(900);
	const location = useLocation();

	const params = location.state?.menu ?? '공지사항';
	const [search, setSearch] = useState('');
	const [page, setPage] = useState(1);
	const [selectedOption, setSelectedOption] = useState('전체');
	const debouncedSearch = useDebounce(search, 300);

	const { data: infoData } = useGetInfoApi({
		page: page,
		search: debouncedSearch,
		search_category: selectedOption,
		type: convertInfoValue(params),
	});

	const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
		setSearch(e.target.value);
	};
	const handleGetPk = (pk: number | string) => {
		navigate(`/infoplace/detail/${pk}`, { state: { menu: params } });
	};
	const handleClickOption = (menu: string) => {
		setPage(1);
		setSearch('');
		navigate('/infoplace', { state: { menu: menu } });
	};

	const getDynamicField = (g: any, field: string) => {
		const type = convertInfoValue(params);

		return g[`${type}_${field}`] || ''; // 동적으로 필드 처리
	};

	return (
		<main>
			<SubBanner subTitle="Information" title="정보광장" img={infoBanner} />
			<TabList menuList={['공지사항', '소식지', '연구동향', '갤러리']} menuKey={params} onListClick={handleClickOption} />
			<S.ConferenceContainer>
				<S.ConferenceTitle>
					{params === '공지사항' ? (
						<>
							한국노화학회의 다양한 소식들을 <br style={isMoble ? {} : { display: 'none' }} />
							신속하게 안내하겠습니다.
						</>
					) : params === '소식지' ? (
						<>
							한국노화학회의 다양한 활동들을 <br style={isMoble ? {} : { display: 'none' }} />
							소식지로 만나실 수 있습니다.
						</>
					) : params === '연구동향' ? (
						<>
							한국노화학회의 다양한 연구들을 <br style={isMoble ? {} : { display: 'none' }} />
							확인해보실 수 있습니다.
						</>
					) : (
						<>
							한국노화학회의 춘계, 추계학술대회
							<br style={isMoble ? {} : { display: 'none' }} /> 현장을 보실 수 있습니다.
						</>
					)}
				</S.ConferenceTitle>

				<S.ConferenceBoardBox>
					<S.ConferenceSearchBox>
						<InputSelect options={tableOptions} selectedOption={selectedOption} setSelectedOption={setSelectedOption} />
						<InputSearch value={search} input={handleSearch} placeholder="검색어 입력" />
					</S.ConferenceSearchBox>
					{infoData && infoData[convertInfoValue(params)]?.length !== 0 ? (
						params !== '갤러리' ? (
							!isMoble ? (
								<TablePagination activePage={page} totalItems={infoData?.[`${convertInfoValue(params)}_count`]} onChange={(page) => setPage(page)}>
									<BoardTable
										columns={generateColumns(infoData[convertInfoValue(params)] ?? [])}
										page={page}
										data={infoData[convertInfoValue(params)] ?? []}
										totalItems={infoData?.[`${convertInfoValue(params)}_count`]}
										onClick={handleGetPk}
									/>
								</TablePagination>
							) : (
								<TablePagination activePage={page} totalItems={infoData?.[`${convertInfoValue(params)}_count`]} onChange={(page) => setPage(page)}>
									<ConferenceList data={infoData[convertInfoValue(params)] ?? []} sort={convertInfoValue(params)} />
								</TablePagination>
							)
						) : (
							<TablePagination activePage={page} totalItems={infoData?.gallery_count} onChange={(page) => setPage(page)}>
								<S.ConferenceGalleryBox>
									{infoData &&
										(infoData[convertInfoValue(params)] ?? []).map((g, index) => (
											<S.GalleryItemBox key={index} onClick={() => navigate(`/infoplace/detail/${getDynamicField(g, 'pk')}`, { state: { menu: params } })}>
												<div className="img_box">
													<img src={getDynamicField(g, 'image_url') || defaultImg} alt="기본 이미지" />
												</div>
												<S.ContentBox>
													<p className="title">{getDynamicField(g, 'title')}</p>
													<p className="date">{dayjs(getDynamicField(g, 'enrollment_date')).format('YYYY-MM-DD')}</p>
												</S.ContentBox>
											</S.GalleryItemBox>
										))}
								</S.ConferenceGalleryBox>
							</TablePagination>
						)
					) : (
						<S.EmptyData>해당 데이터가 없습니다.</S.EmptyData>
					)}
				</S.ConferenceBoardBox>
			</S.ConferenceContainer>
		</main>
	);
};

export default InfoPlace;
